import React, { useEffect, useRef, useState } from 'react'
import { FieldValues } from 'react-hook-form'
import {
  createSubResource,
  DataTypeStore,
  DataTypeStoreExtended,
  ENTITY_TYPE,
  fetchDuplicateRecordsAPI,
  getEntityDataByEntityFilter,
  getLayoutByEntityIdAndTypeApi,
  getSubResources,
  hideLoader,
  isValidEntityDataId,
  LayoutResponseType,
  quarantineAePcIfRejectedApi,
  showLoader,
  transformToDuplicateApiPayload,
  updateSubResource,
  updateSubResource360v1,
} from '@app-store'
import {
  Accordion,
  ACTION_ICONS_NAMESPACE,
  ConfirmDialog,
  CustomButton,
  Loader,
  Modal,
  MODE_CONSTANTS,
  SearchBar,
  SkeletonLoader,
  SvgAssign,
  SvgCross,
  SvgEdit,
  TableActionType,
} from '@ui-kit'
import { isEmpty, noop } from 'lodash'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import { AxiosResponse } from 'axios'
import AddEditRecordPage from '../../pages/AddEditViewRecord.page'
import FormRenderer from '../FormRenderer'
import {
  BUTTONS,
  ENTITY_NAME,
  HTTP_STATUS_CONSTANTS,
  LAYOUT_TYPE_NAMESPACE,
  NAMESPACES,
  RECORD_STATE,
  TABLE_ACTIONS,
} from '../../utils/constants'
// might need later
// import { STRINGS } from '../../utils/strings'
import { EntityLayout, LayoutData, Page } from '../../types/layout.types'
import { Group, MultiLookupRenderTabsTypes } from '../../types/types'
import { ListingTable } from '../listing-table/ListingTable'
import {
  ListingPopoutExpandButton,
  PopoutableListingShell,
} from '../listing-table/PopoutableListingShell'
import {
  ListingTableProps,
  ListingTableRow,
} from '../../types/listingTable.types'
import { TabIndexMap } from '../../types/common'
import {
  generateTabIndexMap,
  getMaxTabIndexValue,
} from '../../utils/tab-indexing'
import {
  ROWS_TAB_DIFFERENCE_FOR_LAYOUT_RENDER_TABS,
  ShortcutKeys,
} from '../../constants/form.constants'
import { isReadOnlyUser } from '../../utils/permission'
import {
  APPLICATION_PREFERENCES_STRINGS,
  DUPLICATION,
} from '../../utils/strings'
import { ListingTableColumn } from '../../utils/types'
import { DuplicationScore } from '../DuplicationScore'
import {
  editEntityDataEmbeddedAPI,
  getEntityData,
} from '../../apis/entityData.api'
import { fetchCaseData, resendCommunication } from '../../utils/helperFunctions'
import PolicyUpdateProcess from '../workflow/PolicyUpdateProcess'

const MultiLookupRenderTabs = ({
  heading,
  listingLayout,
  editLayout,
  relationIdentifier,
  lookupKeyname = '',
  entityIdMultilookup,
  editIdMultilookup,
  layout,
  recordId,
  entityId,
  isAssign,
  disableFilters,
  tabIndexMap,
  handleAccordionClick,
  lookupKeynameForGlobal,
  isWorkflow,
  isViewEntity = false,
}: MultiLookupRenderTabsTypes) => {
  const dataId = recordId
  const dispatch = useAppDispatch()
  const selectedUnassignedIds = useRef<Set<DataTypeStore['id']>>(
    new Set()
  ).current
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] =
    useState<boolean>(false)
  const entitiesByName = useAppSelector(
    (state: RootState) => state.entity.entitiesByName
  )
  const caseData = useAppSelector((state) => state?.workflowData?.caseData)
  const authUser = useAppSelector((state) => state?.authUser)
  const [selectedRow, setSelectedRow] = useState<ListingTableRow | null>(null)
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [addedRecord, setAddedRecord] = useState<FieldValues | null>(null)
  const [duplicateListingLayout, setDuplicateListingLayout] =
    useState<LayoutResponseType>()
  const [refetchKey, setRefetchKey] = useState<number>(0)
  const [viewDuplicateRecord, setViewDuplicateRecord] = useState<boolean>(false)
  const [viewLayout, setViewLayout] = useState<LayoutResponseType>()
  const [viewRecordData, setViewRecordData] = useState<FieldValues>()

  const [isAssignModalOpen, setIsAssignModalOpen] = useState<boolean>(false)
  const [isAddModalOpen, setIsAddModalOpen] = useState<boolean>(false)
  const [selectedRecord, setSelectedRecord] = useState<DataTypeStore | null>(
    null
  )
  const [assignTableKey, setAssignTableKey] = useState(0)
  const [isListingPopoutOpen, setIsListingPopoutOpen] = useState(false)
  const [isAccordionOpen, setIsAccordionOpen] = useState(false)
  const [unAssignTableKey, setUnAssignTableKey] = useState(0)

  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState<boolean>(false)
  const [deletedRow, setDeletedRow] = useState<DataTypeStore>({})
  const [tabIndexMapForAddModal, setTabIndexMapForAddModal] =
    useState<TabIndexMap>({})
  const entityName = listingLayout?.entity_name

  const shouldShowButton = !isViewEntity
    ? !isEmpty(lookupKeyname)
      ? !isEmpty(editIdMultilookup) || !isEmpty(dataId)
      : dataId && editLayout?.id
    : false

  const isPatientInsurancesLookup =
    (lookupKeynameForGlobal ?? lookupKeyname) === 'c_patient_insurances_patient'

  const allowInsuranceAdditionBv =
    String(
      authUser?.site_settings?.find(
        (setting) => setting?.key === 'allow_insurance_addition_bv'
      )?.value ?? ''
    ).toLowerCase() === 'true'

  const canShowAddButton =
    !isReadOnlyUser() &&
    ((lookupKeynameForGlobal ?? lookupKeyname) !==
      'c_case_insurances_c_cases' ||
      allowInsuranceAdditionBv) &&
    !!shouldShowButton

  const renderAddButton = () => {
    if (!canShowAddButton) {
      return null
    }
    return (
      <CustomButton
        height="h-8"
        onClick={(e) => {
          if (isValidEntityDataId(dataId)) {
            e.stopPropagation()
            if (isAssign) {
              toggleAssignModal()
            } else {
              toggleAddModal()
            }
          }
        }}
        tabIndex={tabIndexMap?.tabIndexOffset}
        onKeyDown={(e) => {
          if (e?.key === ShortcutKeys.Enter || e?.key === ShortcutKeys.Space) {
            if (isValidEntityDataId(dataId)) {
              e.stopPropagation()
              if (isAssign) {
                toggleAssignModal()
              } else {
                toggleAddModal()
              }
            }
          }
        }}
      >
        {NAMESPACES.ADD}
      </CustomButton>
    )
  }

  const assignNewData = async (values: FieldValues) => {
    const uploadId = Number(values?.document_upload?.id)
    const hasValidUpload = Number.isFinite(uploadId) && uploadId > 0
    if (!hasValidUpload) {
      delete values.document_upload
    }
    try {
      setIsLoading(true)
      const entityId = listingLayout?.entity_id
      const layoutId = editLayout?.id
      dispatch(showLoader())
      if (
        entityName?.includes(ENTITY_NAME.CASE_DOCUMENTS_LOWER) &&
        hasValidUpload &&
        entitiesByName?.[ENTITY_NAME.AE_PC_DOCUMENT]?.queue_visibility
      ) {
        let programsId = caseData?.programs?.id
        if (!programsId) {
          const caseDataResponse = await fetchCaseData(dataId ?? '', dispatch)
          programsId = caseDataResponse?.data?.programs?.id
        }
        values.c_ae_pc_document = {
          c_cases: {
            id: Number(recordId),
            _state: RECORD_STATE.ADDED,
          },
          ...(values.case_document_type?.id
            ? {
                document_type: {
                  id: values.case_document_type.id,
                  _state: RECORD_STATE.ADDED,
                },
              }
            : {}),
          ...(values.document_upload?.id
            ? {
                documents: {
                  id: values.document_upload.id,
                  _state: RECORD_STATE.ADDED,
                },
              }
            : {}),
          ...(programsId
            ? {
                programs: {
                  id: programsId,
                  _state: RECORD_STATE.ADDED,
                },
              }
            : {}),
          _state: RECORD_STATE.ADDED,
        }
      }
      await createSubResource(
        entityName ?? '',
        entityId?.toString() ?? '',
        layoutId?.toString() ?? '',
        dataId ?? '',
        relationIdentifier ?? '',
        values
      )
      if (
        entityName?.includes(ENTITY_NAME.CASE_DOCUMENTS_LOWER) &&
        hasValidUpload
      ) {
        try {
          await quarantineAePcIfRejectedApi(uploadId)
        } catch (quarantineError) {
          console.error(quarantineError)
        }
      }
      fetchAssignedData()
      setIsAddModalOpen(false)
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
      setIsLoading(false)
      window.location.reload()
    }
  }

  const unAssignData = async (newRow: DataTypeStore) => {
    try {
      dispatch(showLoader())
      if (isEmpty(lookupKeyname)) {
        const finalValue = [newRow]
        await updateSubResource360v1(
          entityId?.toString() ?? '',
          relationIdentifier,
          finalValue,
          dataId ?? '',
          layout?.entity_name ?? '',
          entityName ?? ''
        )
      } else {
        const keyName: string = lookupKeyname
        const finalValue: DataTypeStoreExtended = {}
        finalValue[keyName] = [newRow]
        await updateSubResource(
          entityIdMultilookup ?? '',
          editIdMultilookup ?? '',
          dataId ?? '',
          finalValue,
          NAMESPACES.REMOVED
        )
      }
      fetchAssignedData()
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
      window.location.reload()
    }
  }

  const fetchViewLayout = async () => {
    dispatch(showLoader())
    try {
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: String(editLayout?.entity_id),
        type: LAYOUT_TYPE_NAMESPACE?.OVERVIEW_TYPE,
        isDefault: true,
      })
      if (res?.data) {
        setViewLayout(res?.data?.[0])
        return res?.data?.[0]?.id
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchViewRecordData = async (layoutId: number, id: number) => {
    dispatch(showLoader())
    try {
      const res = await getEntityData(
        String(editLayout?.entity_name),
        Number(editLayout?.entity_id),
        layoutId,
        id
      )
      if (res?.data) {
        setViewRecordData(res?.data)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const extraActions: (TableActionType<DataTypeStore> & {
    onClick?: (row: ListingTableRow, rowIndex: number) => void
  })[] = [
    {
      label: NAMESPACES.VIEW,
      key: ACTION_ICONS_NAMESPACE.VIEW,
      onClick: async (row) => {
        const layoutId = await fetchViewLayout()
        setSelectedRow(row)
        setViewDuplicateRecord(true)
        fetchViewRecordData(layoutId, row?.id)
      },
    },
  ]

  const extraColumn: ListingTableColumn[] = [
    {
      header: '',
      accessor: DUPLICATION.SELECT_ACCESSOR,
      type: DUPLICATION.RADIO_TYPE,
      onClick(_KeyName, row, _rowIndex) {
        setSelectedRow(row)
        setRefetchKey((prev) => prev + 1)
      },
    },
    {
      header: APPLICATION_PREFERENCES_STRINGS.MATCH_SCORE,
      accessor: DUPLICATION.SCORE_ACCESSOR,
      type: DUPLICATION.COMPONENT_TYPE,
      renderComponent: (row) => {
        return (
          <div className="flex items-center gap-1">
            <span>{String(row?.score ?? '')}</span>
            <DuplicationScore
              groups={row?.matchDetails as unknown as Group[]}
            />
          </div>
        )
      },
    },
  ]

  const closeDuplicationModal = () => {
    setAddedRecord(null)
    setIsDuplicateModalOpen(false)
    setViewDuplicateRecord(false)
    setIsAddModalOpen(false)
    setSelectedRow(null)
    fetchAssignedData()
  }

  const createNewRecord = async (values?: FieldValues) => {
    dispatch(showLoader())
    try {
      const entityId = listingLayout?.entity_id
      const layoutId = editLayout?.id
      await createSubResource(
        entityName ?? '',
        entityId?.toString() ?? '',
        layoutId?.toString() ?? '',
        dataId ?? '',
        relationIdentifier ?? '',
        addedRecord ?? values ?? {}
      )
      closeDuplicationModal()
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchListingLayout = async () => {
    try {
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: editLayout?.entity_id.toString() ?? '',
        type: LAYOUT_TYPE_NAMESPACE?.LAYOUT_LISTING,
        isDefault: true,
      })
      if (res?.data) {
        setDuplicateListingLayout(res.data?.[0])
        return res.data?.[0]
      }
    } catch (err) {
      console.log(err)
    }
  }

  const fetchTableDataCallback = async (
    values: FieldValues,
    listingLayoutId: string | number,
    payload?: getEntityDataByEntityFilter['payload'] & { layout_id: number }
  ) => {
    if (listingLayoutId) {
      const duplicateApiPayload = transformToDuplicateApiPayload(
        values,
        editLayout?.entity_id?.toString() ?? '',
        listingLayoutId?.toString(),
        editLayout ?? undefined
      )
      const res = await fetchDuplicateRecordsAPI(
        editLayout?.entity_id ?? 0,
        duplicateApiPayload,
        payload?.page as number,
        payload?.size as number
      )
      const addSelectedFlag = (data: ListingTableRow[]) => {
        return data.map((row) => ({
          ...row,
          select: row?.id === selectedRow?.id ? true : false,
        }))
      }
      res.data.content = addSelectedFlag(res?.data?.content)
      setTotalRecords(res?.data?.totalElements ?? 0)

      if (res?.data?.content.length !== 0) {
        setAddedRecord(values)
        setIsDuplicateModalOpen(true)
      } else {
        createNewRecord(values)
      }
      return res?.data
    }
  }

  const handleAssignNewData = async (
    finalvalues: FieldValues,
    _embedded: string[],
    originalFormData: FieldValues | undefined
  ) => {
    if (!editLayout) {
      return
    }
    dispatch(showLoader())
    try {
      const values = { ...finalvalues, ...originalFormData }
      const entity = entitiesByName[editLayout?.entity_name ?? '']
      if (entity?.is_duplicate) {
        const listingLayout = await fetchListingLayout()
        await fetchTableDataCallback(values, listingLayout?.id)
      } else {
        assignNewData(values)
      }
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const toggleAssignModal = () => {
    setIsAddModalOpen(false)
    setIsAssignModalOpen((prev) => !prev)
    if (!isAssignModalOpen) {
      handleAccordionClick?.(true)
      fetchUnassignedData()
    } else {
      fetchAssignedData()
    }
  }

  const toggleAddModal = () => {
    handleAccordionClick?.(true)
    setIsAssignModalOpen(false)
    setSelectedRecord(null)
    setIsAddModalOpen((prev) => !prev)
  }

  const toggleConfirmModal = () => {
    setIsConfirmModalOpen((prev) => !prev)
    if (isConfirmModalOpen === false) {
      fetchAssignedData()
    }
  }

  const fetchUnassignedDataCallback: ListingTableProps['dataFetchCallback'] =
    async (payload) => {
      if (!isValidEntityDataId(dataId)) {
        return {
          content: [],
          totalElements: 0,
          totalPages: 0,
          size: 0,
          number: 0,
        }
      }
      const entityId = listingLayout?.entity_id
      const layoutId = listingLayout?.id?.toString()
      const response = await getSubResources(
        entityName ?? '',
        entityId?.toString() ?? '',
        layoutId ?? '',
        relationIdentifier,
        true,
        dataId ?? '',
        +payload.page,
        +payload.size,
        undefined,
        payload.filters,
        payload.select,
        payload.related_entities,
        listingLayout?.function_parameters
      )

      response?.data?.content?.forEach((row: DataTypeStore) => {
        row.selected = selectedUnassignedIds.has(row.id)
      })

      return response.data
    }

  const fetchUnassignedData = () => {
    setUnAssignTableKey((key) => key + 1)
  }
  const fetchAssignedData = () => {
    setAssignTableKey((key) => key + 1)
  }

  const fetchAssignedDataCallback: ListingTableProps['dataFetchCallback'] =
    async (payload) => {
      if (!isValidEntityDataId(dataId)) {
        return {
          content: [],
          totalElements: 0,
          totalPages: 0,
          size: 0,
          number: 0,
        }
      }
      const layoutId = listingLayout?.id?.toString()
      const entityId = listingLayout?.entity_id?.toString()
      const response = await getSubResources(
        entityName ?? '',
        entityId ?? '',
        layoutId ?? '',
        relationIdentifier,
        false,
        dataId || '',
        +payload.page,
        +payload.size,
        undefined,
        payload.filters,
        payload.select,
        payload.related_entities,
        listingLayout?.function_parameters
      )

      return response.data
    }

  const assignData = async () => {
    try {
      dispatch(showLoader())
      const value = Array.from(selectedUnassignedIds).map((id) => ({
        id,
        _state: 'ADDED',
      }))
      let response: AxiosResponse<unknown, unknown>
      if (isEmpty(lookupKeyname)) {
        response = await updateSubResource360v1(
          entityId?.toString() || '',
          relationIdentifier,
          value,
          dataId || '',
          layout?.entity_name ?? '',
          entityName ?? ''
        )
      } else {
        const keyName: string = lookupKeyname
        const finalValue: { [key: string]: typeof value } = {}
        finalValue[keyName] = value
        response = await updateSubResource(
          entityIdMultilookup ?? '',
          editIdMultilookup ?? '',
          dataId || '',
          finalValue,
          NAMESPACES.CHANGED
        )
      }
      if (response.status === HTTP_STATUS_CONSTANTS.SUCCESS) {
        toggleAssignModal()
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const deleteRow = (tableRow: DataTypeStore) => {
    if (tableRow) {
      const newRow = {
        id: tableRow.id,
        name: tableRow.name,
        _state: 'REMOVED',
      }
      unAssignData(newRow)
      setIsConfirmModalOpen(false)
    }
  }

  const editRow = (tableRow: DataTypeStore) => {
    setIsEditModalOpen(true)
    setSelectedRecord(tableRow)
  }

  const onSaveClick = (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e && e.preventDefault()
    setIsEditModalOpen(false)
    fetchAssignedData()
  }

  const getActions = (): ListingTableProps['extraActions'] => {
    if (
      (lookupKeynameForGlobal ?? lookupKeyname) ===
        'communications_communication_cases' &&
      isWorkflow
    ) {
      return [
        {
          label: BUTTONS.RESEND,
          key: 'TABLE_ACTIONS.',
          renderActionComponent: (row) => {
            const communicationKey = row?.communication_id
              ?.toString()
              ?.toLowerCase()

            if (communicationKey?.startsWith('i')) {
              return null
            }

            return (
              <CustomButton
                isFilled
                onClick={() =>
                  resendCommunication(
                    row?.id as unknown as number,
                    setAssignTableKey
                  )
                }
              >
                {BUTTONS.RESEND}
              </CustomButton>
            )
          },
        },
      ]
    }

    if (
      (lookupKeynameForGlobal ?? lookupKeyname) === 'c_case_insurances_c_cases'
    )
      return []
    if (lookupKeyname) {
      if (
        editIdMultilookup &&
        listingLayout?.entity?.entity_type !== ENTITY_TYPE?.VIEW
      ) {
        return [
          {
            label: NAMESPACES.EDIT_BUTTON,
            key: TABLE_ACTIONS.EDIT,
            icon: <SvgEdit />,
            onClick: (row) => {
              editRow(row)
            },
          },
          {
            label: NAMESPACES.REMOVE_BUTTON,
            key: TABLE_ACTIONS.REMOVE,
            icon: <SvgCross />,
            onClick: (row) => {
              setDeletedRow(row)
              setIsConfirmModalOpen(true)
            },
          },
        ]
      } else {
        return []
      }
    } else if (
      editLayout &&
      listingLayout?.entity?.entity_type !== ENTITY_TYPE?.VIEW
    ) {
      return [
        {
          label: NAMESPACES.EDIT_BUTTON,
          key: TABLE_ACTIONS.EDIT,
          icon: <SvgEdit />,
          onClick: (row) => {
            editRow(row)
          },
        },
        {
          label: NAMESPACES.REMOVE_BUTTON,
          key: TABLE_ACTIONS.REMOVE,
          icon: <SvgCross />,
          onClick: (row) => {
            setDeletedRow(row)
            setIsConfirmModalOpen(true)
          },
        },
      ]
    } else {
      return []
    }
  }

  const params = new URLSearchParams(window.location.search)
  const isCorrespondenceRoute =
    isWorkflow &&
    decodeURIComponent(params.get('tabs') || '').toLowerCase() ===
      'correspondence'

  const linkCaseWithPharmacy = async () => {
    try {
      dispatch(showLoader())
      const data = {
        [lookupKeynameForGlobal ?? lookupKeyname ?? '']: [
          {
            id: selectedRow?.id,
            _state: 'ADDED',
          },
        ],
      }
      await editEntityDataEmbeddedAPI('case', dataId, data, [
        lookupKeynameForGlobal ?? lookupKeyname ?? '',
      ])
      closeDuplicationModal()
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  useEffect(() => {
    selectedUnassignedIds.clear()
  }, [isAssignModalOpen])

  useEffect(() => {
    if (isAddModalOpen) {
      setTabIndexMapForAddModal(
        generateTabIndexMap(
          (editLayout?.layout_data?.pages as unknown as Page[]) ?? [],
          ROWS_TAB_DIFFERENCE_FOR_LAYOUT_RENDER_TABS
        )
      )
    }
  }, [editLayout?.layout_data, isAddModalOpen])

  return (
    <div>
      {isEditModalOpen && (
        <Modal
          isOpen={isEditModalOpen}
          closeModal={() => setIsAddModalOpen(false)}
          showCloseButton={false}
          width="min-w-[75vw] max-w-[98%]"
          isResizable
        >
          <div className="flex">
            <div className="w-full">
              <AddEditRecordPage
                mode="edit"
                layoutId={editLayout?.id?.toString()}
                entityId={editLayout?.entity_id?.toString()}
                id={selectedRecord?.id?.toString() ?? ''}
                loaderVisible={false}
                allowNavigate={false}
                onSaveClick={onSaveClick}
                shouldModalOpen={false}
                onCancel={() => {
                  setIsEditModalOpen(false)
                  fetchAssignedData()
                }}
                addAEPCDocument={
                  entityName === ENTITY_NAME.CASE_DOCUMENTS_LOWER &&
                  !!Object.keys(
                    listingLayout?.layout_data?.added_fields || {}
                  ).find((key) => key === ENTITY_NAME.C_AE_PC_DOCUMENT)
                    ? selectedRecord
                    : undefined
                }
                //TODO: Might require later
                // showFooter={true}
              />
            </div>
          </div>
        </Modal>
      )}
      {isAddModalOpen && (
        <Modal
          isOpen={isAddModalOpen}
          closeModal={toggleAddModal}
          showCloseButton={false}
          width="min-w-[75vw] max-w-[98%]"
          isResizable
        >
          {isLoading ? (
            <Loader isGlobal={false} loaderHeight="40" loaderWidth="40" />
          ) : (
            <div className="">
              {editLayout && !isDuplicateModalOpen && !viewDuplicateRecord ? (
                <FormRenderer
                  heading={
                    <div className="flex items-center justify-between gap-4 mb-2">
                      <span className="font-medium text-base font-primary">
                        Add{' '}
                        {editLayout?.layout_data?.pages?.[0]?.rows?.[0]?.label}{' '}
                      </span>
                      <div className="flex gap-3">
                        <CustomButton
                          onClick={() => {
                            setIsAddModalOpen(false)
                          }}
                          dataQaId={NAMESPACES.CANCEL_TABS_MULTTI}
                          tabIndex={getMaxTabIndexValue({
                            tabIndexMapForAddModal,
                          })}
                        >
                          <span>{NAMESPACES.CANCEL_BUTTON}</span>
                        </CustomButton>
                        <CustomButton
                          isFilled
                          type="submit"
                          tabIndex={getMaxTabIndexValue({
                            tabIndexMapForAddModal,
                          })}
                        >
                          <span>{NAMESPACES.SAVE_BUTTON}</span>
                        </CustomButton>
                      </div>
                      {/* //TODO: Might re */}
                      {/* <div className="flex items-center gap-3">
                        <div className="cursor-pointer">
                          <SvgCross onClick={toggleAddModal} />
                        </div>
                      </div> */}
                    </div>
                  }
                  layout={editLayout?.layout_data as LayoutData}
                  mode={MODE_CONSTANTS?.ADD}
                  handleFormSubmit={handleAssignNewData}
                  data={selectedRecord ?? addedRecord ?? {}}
                  //TODO: might need to change later
                  // footer={
                  //   <div className="flex items-center justify-end gap-4 mt-4">
                  //     <div className="flex items-center gap-3">
                  //        <div className="flex gap-3">
                  //         <CustomButton
                  //           onClick={() => {
                  //             setIsAddModalOpen(false)
                  //           }}
                  //           dataQaId={NAMESPACES.CANCEL_TABS_MULTTI}
                  //           tabIndex={getMaxTabIndexValue({
                  //             tabIndexMapForAddModal,
                  //           })}
                  //         >
                  //           <span>{NAMESPACES.CANCEL_BUTTON}</span>
                  //         </CustomButton>
                  //         <CustomButton
                  //           isFilled
                  //           type="submit"
                  //           tabIndex={getMaxTabIndexValue({
                  //             tabIndexMapForAddModal,
                  //           })}
                  //         >
                  //           <span>{NAMESPACES.SAVE_BUTTON}</span>
                  //         </CustomButton>
                  //       </div>
                  //     </div>
                  //   </div>
                  // }
                  fullLayout={editLayout as EntityLayout}
                  tabIndexMap={tabIndexMapForAddModal}
                />
              ) : isDuplicateModalOpen ? (
                <div className="flex flex-col gap-2">
                  <div className="flex justify-between items-center">
                    <div>
                      <span
                        className="font-medium text-base font-primary cursor-pointer"
                        onClick={() => {
                          setViewDuplicateRecord(false)
                          setIsDuplicateModalOpen(false)
                          setSelectedRow(null)
                        }}
                      >
                        {`${NAMESPACES.ADD} ${editLayout?.layout_data?.pages?.[0]?.rows?.[0]?.label}`}
                      </span>
                      <span
                        className={`font-medium text-base font-primary cursor-pointer ${
                          !viewDuplicateRecord ? `text-primary-500` : ``
                        }`}
                        onClick={() => {
                          setViewDuplicateRecord(false)
                        }}
                      >
                        {` / ${APPLICATION_PREFERENCES_STRINGS?.DUPLICATE_HEADING}`}
                      </span>
                      {viewDuplicateRecord && (
                        <span className="font-medium text-base font-primary cursor-pointer text-primary-500">
                          {` / ${NAMESPACES.VIEW} ${editLayout?.layout_data?.pages?.[0]?.rows?.[0]?.label}`}
                        </span>
                      )}
                    </div>
                    <div className="flex gap-2">
                      <CustomButton isFilled onClick={createNewRecord}>
                        {APPLICATION_PREFERENCES_STRINGS?.CREATE_ANYWAY}
                      </CustomButton>
                      <CustomButton
                        isFilled
                        onClick={() => {
                          linkCaseWithPharmacy()
                        }}
                        disabled={isEmpty(selectedRow)}
                      >
                        {APPLICATION_PREFERENCES_STRINGS?.USE_EXISTING}
                      </CustomButton>
                    </div>
                  </div>
                  {!viewDuplicateRecord ? (
                    <>
                      <span className="font-light text-xs pb-2">
                        {totalRecords}{' '}
                        {APPLICATION_PREFERENCES_STRINGS.RECORDS_FOUND}
                      </span>
                      <ListingTable
                        isMultiLookup={true}
                        entityId={Number(editLayout?.entity_id)}
                        entityName={editLayout?.entity_name ?? ''}
                        extraActions={extraActions}
                        layout={duplicateListingLayout}
                        dataFetchCallback={(payload) =>
                          fetchTableDataCallback(
                            addedRecord ?? {},
                            listingLayout?.id ?? 0,
                            payload
                          )
                        }
                        extraColumns={extraColumn}
                        hideFilters={true}
                        refetchKey={refetchKey}
                        openInNewTab={true}
                      />
                    </>
                  ) : (
                    <FormRenderer
                      heading={null}
                      layout={viewLayout?.layout_data as LayoutData}
                      mode={MODE_CONSTANTS?.VIEW}
                      handleFormSubmit={noop}
                      fullLayout={viewLayout as EntityLayout}
                      data={viewRecordData}
                    />
                  )}
                </div>
              ) : null}
            </div>
          )}
        </Modal>
      )}
      {isConfirmModalOpen && (
        <ConfirmDialog
          open={isConfirmModalOpen}
          message={NAMESPACES.UNASSIGN_CONFIRMATION}
          onConfirm={() => deleteRow(deletedRow)}
          onCancel={toggleConfirmModal}
        />
      )}
      {isAssignModalOpen && (
        <div>
          <Modal
            isOpen={isAssignModalOpen}
            closeModal={toggleAssignModal}
            showCloseButton={false}
            width="min-w-[75vw] max-w-[98%]"
            isResizable
          >
            {isLoading ? (
              <Loader isGlobal={false} loaderHeight="40" loaderWidth="40" />
            ) : null}
            {
              <div className={`${isLoading ? 'hidden' : ''}`}>
                {' '}
                <div className="flex items-center justify-between gap-4 font-primary">
                  <span className="font-medium text-base">
                    Assign{' '}
                    {editLayout?.layout_data?.pages?.[0]?.rows?.[0]?.label}{' '}
                  </span>
                  <div className="flex items-center gap-4">
                    <SearchBar
                      onSearch={noop}
                      showFunnel={false}
                      height="h-10"
                      width="w-44"
                    />

                    <CustomButton
                      onClick={toggleAssignModal}
                      dataQaId={NAMESPACES.ASSIGN_TABS_MULTI}
                    >
                      <span>{NAMESPACES.CANCEL_BUTTON}</span>
                    </CustomButton>
                    <CustomButton
                      onClick={toggleAddModal}
                      dataQaId={NAMESPACES.ADD_TABS_MULTI}
                    >
                      <div className="flex items-center justify-center gap-1">
                        <SvgAssign className="svg-path-fill-primary-500 fill-primary-500" />
                        <span className="text-accent-900 font-light text-xs">
                          {NAMESPACES.ADD}
                        </span>
                      </div>
                    </CustomButton>
                    <CustomButton isFilled onClick={assignData}>
                      <span>{NAMESPACES.CONFIRM}</span>
                    </CustomButton>

                    {/* <div className="cursor-pointer w-[0.875rem] h-[0.875rem]">
                      <SvgCross onClick={toggleAssignModal} />
                    </div> */}
                  </div>
                </div>
                <div className="pt-4 font-medium font-primary">
                  {listingLayout ? (
                    <ListingTable
                      isMultiLookup={true}
                      refetchKey={unAssignTableKey}
                      entityId={listingLayout.entity_id}
                      entityName={entityName ?? ''}
                      layout={listingLayout}
                      dataFetchCallback={fetchUnassignedDataCallback}
                      extraColumns={[
                        {
                          accessor: 'selected',
                          type: 'checkbox',
                          onClick: (accessor, row) => {
                            row[accessor] = !row[accessor]
                            if (selectedUnassignedIds.has(row.id))
                              selectedUnassignedIds.delete(row.id)
                            else selectedUnassignedIds.add(row.id)
                          },
                        },
                      ]}
                      noDataScreen={NoDataScreen}
                      hideFilters={disableFilters}
                    />
                  ) : (
                    <SkeletonLoader />
                  )}
                </div>
                {/* <div className="flex pt-10 gap-3 justify-end">
                  <CustomButton
                    onClick={toggleAssignModal}
                    dataQaId={NAMESPACES.ASSIGN_TABS_MULTI}
                  >
                    <span>{NAMESPACES.CANCEL_BUTTON}</span>
                  </CustomButton>
                  <CustomButton isFilled onClick={assignData}>
                    <span>{NAMESPACES.CONFIRM}</span>
                  </CustomButton>
                </div>{' '} */}
              </div>
            }
          </Modal>
        </div>
      )}
      <Accordion
        handleAccordionClick={(expanded) => {
          if (expanded) {
            setIsAccordionOpen(expanded)
          }
          if (isListingPopoutOpen && !expanded) {
            return
          }
          handleAccordionClick?.(expanded)
        }}
        heading={
          <div className="flex justify-between items-center">
            <span className="font-primary">{heading}</span>
            <div className="flex items-center gap-2">
              {isValidEntityDataId(dataId) &&
              isAccordionOpen &&
              listingLayout ? (
                <ListingPopoutExpandButton
                  onClick={() => {
                    setIsListingPopoutOpen(true)
                  }}
                  disabled={isListingPopoutOpen}
                  tabIndex={tabIndexMap?.tabIndexOffset}
                />
              ) : null}
              {isPatientInsurancesLookup && (
                <div onClick={(e) => e.stopPropagation()}>
                  <PolicyUpdateProcess
                    tabIndex={tabIndexMap?.tabIndexOffset}
                    heightClass="h-8"
                  />
                </div>
              )}
              {renderAddButton()}
            </div>
          </div>
        }
        tabIndex={tabIndexMap?.tabIndexOffset}
        triggerOpen={isCorrespondenceRoute}
      >
        <div className="py-2 w-full">
          {!isValidEntityDataId(dataId) ? (
            <div className="flex justify-center items-center h-full m-auto font-primary text-center min-h-20">
              <span>{NAMESPACES.ADD_MODE_MULTILOOKUP}</span>
            </div>
          ) : listingLayout ? (
            <PopoutableListingShell
              isOpen={isListingPopoutOpen}
              onClose={() => setIsListingPopoutOpen(false)}
              title={heading ?? ''}
              headerActions={renderAddButton()}
              disableFocusTrap={
                isAddModalOpen ||
                isEditModalOpen ||
                isAssignModalOpen ||
                isConfirmModalOpen ||
                isDuplicateModalOpen
              }
            >
              <ListingTable
                isMultiLookup={true}
                refetchKey={assignTableKey}
                entityId={+listingLayout.entity_id}
                entityName={entityName ?? ''}
                layout={listingLayout}
                dataFetchCallback={fetchAssignedDataCallback}
                extraActions={isReadOnlyUser() ? [] : getActions()}
                noDataScreen={NoMultiLookUpDataScreen}
                tabIndex={tabIndexMap?.tabIndexOffset}
                hideFilters={disableFilters}
                minHeight={isListingPopoutOpen ? '7rem' : undefined}
              />
            </PopoutableListingShell>
          ) : (
            <SkeletonLoader />
          )}
        </div>
      </Accordion>
    </div>
  )
}
const NoDataScreen = () => {
  return (
    <div className="flex justify-center items-center h-full font-primary text-center min-h-20">
      <div>
        <span>{NAMESPACES.EMPTY_DATA_UNASSIGNED}</span>
      </div>
    </div>
  )
}
const NoMultiLookUpDataScreen = () => (
  <div className="flex justify-center items-center h-full m-auto font-primary text-center  min-h-20">
    <span>{NAMESPACES.EMPTY_DATA_MULTILOOKUP}</span>
  </div>
)
export default MultiLookupRenderTabs
